import { useMgPrisConfig } from '@retail/app/stores/app-config';
import { useAuthContext } from '@retail/auth/data-access';
import { QueryOptions } from '@shared/fetch-utils';
import {
  MutateItemDTO,
  AssortmentItemImportResultDTO,
  AssortmentItemUpload,
} from '@retail/my-assortment/types';
import { useMutateMPEFetch } from '@retail/app/hooks';
import { buildUrl } from '@shared/utils';
import { mpeApi } from '@retail/mgpris/config';

export function useMutateAddItemsToAssortment({ ...queryOptions }: QueryOptions) {
  const { mpe } = useMgPrisConfig();
  const { token } = useAuthContext();

  return useMutateMPEFetch<void, MutateItemDTO[]>({
    method: 'POST',
    url: buildUrl({
      base: mpe.url,
      route: mpeApi.assortments.items.fullRoutePath,
    }),
    token,
    ...queryOptions,
  });
}

interface AssortmentProps extends QueryOptions {
  assortmentId: number;
}

export function useMutateImportAndValidatePriorities({
  assortmentId,
  ...queryOptions
}: AssortmentProps) {
  const { mpe } = useMgPrisConfig();
  const { token } = useAuthContext();

  return useMutateMPEFetch<AssortmentItemImportResultDTO[], AssortmentItemUpload[]>({
    method: 'POST',
    url: () =>
      buildUrl({
        base: mpe.url,
        route: mpeApi.mgSupplierItems.lookup.assortmentItem.getFullLinkPath(),
        searchParams: { assortmentId },
      }),
    token,
    ...queryOptions,
  });
}
